//captcha init
var captchaWidgetId;

var webinarModalForm = (function () {
  var csrf_token;

  function init() {
    uiBindings();
  }

  var uiBindings = function () {
    var openWebinarModalForm = document.querySelectorAll('.open-webinar-modal-form');

    for (var i = 0; i < openWebinarModalForm.length; i++) {
      openWebinarModalForm[i].addEventListener(
        'click',
        function (evt) {
          evt.preventDefault();

          loadRecaptchaForDemoModal(); // load recaptcha for webinar demo form

          captchaWidgetId = undefined;

          var modalContainer = document.querySelector('.webinar-modal-form'),
            that = this;
          if (modalContainer) {
            webinarModal = new tingle.modal({
              focusAfterClosed: this,
              cssClass: ['webinar-pop-up-form', 'style-2'],
              onClose: function () {
                //Close Event
                webinarModal.destroy();
              },
            });
            webinarModal.setContent(modalContainer.innerHTML);
            webinarModal.open();

            var getModalFormTags = document.getElementById('webinar-modal-tag'),
              getModalCampaignID = document.getElementById('webinar-modal-campaign-id'),
              getModalMailchimpID = document.getElementById('webinar-modal-list-id'),
              getModalYTVideoLink = document.getElementById('webinar-modal-yt-link'),
              setModalPageViewValue = document.getElementById('webinar-modal-page-view'),
              sfdcCampaignCode = document.querySelector('[name="webinar_modal_utm_campaigncode"]'),
              sfdcAdditionalNotes = document.querySelector('[name="webinar_modal_additional_notes"]'),
              sfdcPrimaryProduct = document.querySelector('[name="webinar_modal_primary_product"]'),
              sfdcSecondaryProduct = document.querySelector('[name="webinar_modal_secondary_product"]');

            // set hidden field value
            getModalFormTags.value = that.getAttribute('data-mailchimp-tag');
            getModalCampaignID.value = that.getAttribute('data-campaign-id');
            getModalMailchimpID.value = that.getAttribute('data-mailchimp-id');
            getModalYTVideoLink.value = that.getAttribute('data-video-id');
            setModalPageViewValue.value = that.getAttribute('data-mailchimp-tag');

            //set SFDC field values
            sfdcCampaignCode.value = that.getAttribute('data-sfdc-campaign-code');
            sfdcAdditionalNotes.value = that.getAttribute('data-sfdc-additional-notes');
            sfdcPrimaryProduct.value = that.getAttribute('data-sfdc-primary-product');
            sfdcSecondaryProduct.value = that.getAttribute('data-sfdc-secondary-product');

            //form initialise
            webinarModalFormInit();
          }
        },
        false
      );
    }
  };

  function webinarModalFormInit() {
    // Set the page URL hidden field with page url value
    var getCurrentPageURL = window.location.href,
      getPageURLInput = document.getElementById('webinar-modal-page-url');

    if (getPageURLInput) {
      getPageURLInput.value = getCurrentPageURL.trim();
    }

    // render recaptcha for modal form
    if (!captchaWidgetId) {
      captchaWidgetId = renderWebinarCaptchaField();
    }

    var emailField = document.getElementById('webinar-modal-email');
    if (emailField) {
      //focus
      emailField.addEventListener('focus', function () {
        var that = this,
          emailError = document.getElementById('webinar-email-error');

        //remove existing error
        if (emailError) {
          emailError.remove();
        }

        that.classList.remove('error-border');

        if (!csrf_token) {
          // XHR request for user token
          bsLib.ajax(
            'GET',
            bsLib.railsHost() + '/user/token.json',
            {},
            false,
            {},
            // Success message for user token.
            function (data) {
              var dataRequest = bsLib.JSONParse(data.response);
              csrf_token = dataRequest.csrf_token;
            },
            // Custom Error message for user token.
            function () {
              return 'user token not working';
            }
          );
        }
      });
      //blur
      emailField.addEventListener('blur', function (event) {
        var validEmail = true,
          that = this,
          submitBtn = document.getElementById('webinar-modal-submit'),
          emailError = document.getElementById('webinar-email-error');

        //false valid dataset
        that.dataset.notvalid = '0';

        //remove existing error
        if (emailError) {
          emailError.remove();
        }

        // render recaptcha for modal form
        if (!captchaWidgetId) {
          captchaWidgetId = renderWebinarCaptchaField();
        }

        if (that.value.trim().length == 0 || !bsLib.validEmail(that.value.trim())) {
          validEmail = false;

          that.classList.add('error-border');
          that.insertAdjacentHTML(
            'afterend',
            '<span class="error-message" id="webinar-email-error">' +
              (that.value.trim().length == 0
                ? Messages.salesAndSupportPage.noemail
                : Messages.salesAndSupportPage.invalidEmail) +
              '</span>'
          );
        } else {
          that.classList.remove('error-border');
        }

        if (validEmail) {
          //Disable submit button
          if (submitBtn) {
            submitBtn.setAttribute('disabled', 'disabled');
            submitBtn.value = Messages.salesAndSupportPage.validateText;
          }

          bsLib.ajax(
            'GET',
            bsLib.railsHost() +
              '/marketing_api/check_email_validation?email=' +
              encodeURIComponent(that.value.trim()) +
              '&source=paid_ads',
            {},
            true,
            {
              'X-CSRF-Token': csrf_token,
              'content-type': 'application/x-www-form-urlencoded; charset=utf-8', // Setting content type.
            },
            function (data) {
              var dataRequest = bsLib.JSONParse(data.response);

              //remove disable
              if (submitBtn) {
                submitBtn.removeAttribute('disabled');
                submitBtn.value = submitBtn.dataset.btntext;
              }

              if (dataRequest.valid === false) {
                that.dataset.notvalid = '1';

                that.classList.add('error-border');
                if (that.parentNode.getElementsByClassName('error-message').length === 0) {
                  that.insertAdjacentHTML(
                    'afterend',
                    '<span class="error-message" id="webinar-email-error">' +
                      Messages.salesAndSupportPage.invalidWorkEmail +
                      '</span>'
                  );
                }
              }
            },
            function () {}
          );
        }
      });
    }
  }

  function loadRecaptchaForDemoModal() {
    // load recaptcha JS after page load
    document.addEventListener('click', function (e) {
      var captchaField = document.getElementById('recaptcha-js');

      if (!captchaField && typeof grecaptcha === 'undefined') {
        var scriptElm = document.createElement('script');
        scriptElm.setAttribute('id', 'recaptcha-js');
        scriptElm.setAttribute('type', 'text/javascript');
        scriptElm.setAttribute('src', 'https://www.google.com/recaptcha/api.js?ver=1.0');
        scriptElm.setAttribute('defer', 'defer');
        document.body.appendChild(scriptElm);
      }
    });
  }

  init();
})();

function renderWebinarCaptchaField() {
  //remove captcha
  var captchaWidget,
    modalTingle = document.getElementById('tingle-modal-box'),
    captchaFieldShow = document.querySelector('.g-recaptcha.show'),
    captchaField = document.getElementById('webinarformcaptcha');
  //remove all grecaptcha from dom
  if (captchaFieldShow && typeof grecaptcha !== 'undefined') {
    if (captchaFieldShow.innerHTML !== '') {
      captchaFieldShow.innerHTML = '';
    }
  }

  //recaptcha render from JS
  if (
    typeof grecaptcha !== 'undefined' &&
    typeof grecaptcha.render !== 'undefined' &&
    captchaField.childNodes.length === 0
  ) {
    captchaWidget = grecaptcha.render(captchaField, {
      sitekey: captchaField.dataset.sitekey,
      theme: 'light',
      badge: 'bottomleft',
      size: 'invisible',
      callback: function () {
        return webinarModalFormValidation(captchaWidget);
      },
    });

    modalTingle.dataset.gWidgetId = captchaWidget;
  } else if (typeof grecaptcha !== 'undefined' && captchaField.childNodes.length >= 0) {
    captchaWidget = modalTingle.dataset.gWidgetId;
  }
  return captchaWidget;
}

//form those have captcha
function webinarFormValidationCaptcha(captchaWidgetId) {
  var ContactForm = {};
  ContactForm.fnameField = document.getElementById('webinar-modal-fname');
  ContactForm.emailField = document.getElementById('webinar-modal-email');
  ContactForm.lnameField = document.getElementById('webinar-modal-lname');

  // Error fields creation
  ContactForm.fnameError = document.getElementById('webinar-fname-error');
  ContactForm.webinarModalEmailError = document.getElementById('webinar-email-error');
  ContactForm.lnameError = document.getElementById('webinar-lname-error');

  // render recaptcha for modal form
  if (!captchaWidgetId) {
    captchaWidgetId = renderWebinarCaptchaField();
  }

  function form_validation(fieldName, fieldError, idError, errorMessage, isEmail, isSelectBox, emailErrorMessage) {
    if (fieldError) {
      fieldError.remove();
    }

    if (!isEmail) {
      if (fieldName) {
        if (fieldName.value.trim() == '') {
          if (isSelectBox) {
            fieldName.nextSibling.insertAdjacentHTML(
              'afterend',
              '<span class="error-message" id="' + idError + '">' + errorMessage + '</span>'
            );
            fieldName.nextSibling.classList.add('error-border');
          } else {
            fieldName.classList.add('error-border');
            fieldName.insertAdjacentHTML(
              'afterend',
              '<span class="error-message" id="' + idError + '">' + errorMessage + '</span>'
            );
          }
        } else {
          fieldName.classList.remove('error-border');
          if (isSelectBox) {
            fieldName.nextSibling.classList.remove('error-border');
          }
        }
      }
    } else {
      if (fieldName) {
        if (fieldName.value.trim() == '') {
          fieldName.classList.add('error-border');
          fieldName.insertAdjacentHTML(
            'afterend',
            '<span class="error-message" id="' + idError + '">' + errorMessage + '</span>'
          );
        } else if (!bsLib.validEmail(fieldName.value.trim())) {
          fieldName.classList.add('error-border');
          fieldName.insertAdjacentHTML(
            'afterend',
            '<span class="error-message" id="' + idError + '">' + emailErrorMessage + '</span>'
          );
        } else {
          fieldName.classList.remove('error-border');
        }
      }
    }
  }

  form_validation(
    ContactForm.fnameField,
    ContactForm.fnameError,
    'webinar-fname-error',
    'please share your first name',
    false,
    false
  );
  form_validation(
    ContactForm.emailField,
    ContactForm.webinarModalEmailError,
    'webinar-email-error',
    'please share your email address',
    true,
    false,
    'please share your vaild email address'
  );
  form_validation(
    ContactForm.lnameField,
    ContactForm.lnameError,
    'webinar-lname-error',
    'please share your last name',
    false,
    false
  );

  function contactform_field(field) {
    if (field) {
      return field.value.trim();
    }
    return false;
  }

  if (
    contactform_field(ContactForm.fnameField) === '' ||
    contactform_field(ContactForm.emailField) === '' ||
    !bsLib.validEmail(ContactForm.emailField.value.trim()) ||
    contactform_field(ContactForm.lnameField) === ''
  ) {
    return false;
  } else if (ContactForm.emailField.dataset.notvalid === '1') {
    //check valid email from rails api

    if (ContactForm.emailError) {
      ContactForm.emailError.remove();
    }

    ContactForm.emailField.classList.add('error-border');
    ContactForm.emailField.insertAdjacentHTML(
      'afterend',
      '<span class="error-message" id="webinar-email-error">' +
        Messages.salesAndSupportPage.invalidWorkEmail +
        '</span>'
    );

    return false;
  } else {
    if (typeof grecaptcha !== 'undefined') {
      grecaptcha.execute(captchaWidgetId);
    }
  }
  return false;
}

function webinarModalFormValidation(captchaWidgetId) {
  var ContactForm = {},
    websiteHost = window.location.protocol + '//' + window.location.hostname;
  ContactForm.fnameField = document.getElementById('webinar-modal-fname');
  ContactForm.emailField = document.getElementById('webinar-modal-email');
  ContactForm.lnameField = document.getElementById('webinar-modal-lname');

  // Error fields creation
  ContactForm.fnameError = document.getElementById('webinar-fname-error');
  ContactForm.webinarModalEmailError = document.getElementById('webinar-email-error');
  ContactForm.lnameError = document.getElementById('webinar-lname-error');

  function form_validation(fieldName, fieldError, idError, errorMessage, isEmail, isSelectBox, emailErrorMessage) {
    if (fieldError) {
      fieldError.remove();
    }

    if (!isEmail) {
      if (fieldName) {
        if (fieldName.value.trim() == '') {
          if (isSelectBox) {
            fieldName.nextSibling.insertAdjacentHTML(
              'afterend',
              '<span class="error-message" id="' + idError + '">' + errorMessage + '</span>'
            );
            fieldName.nextSibling.classList.add('error-border');
          } else {
            fieldName.classList.add('error-border');
            fieldName.insertAdjacentHTML(
              'afterend',
              '<span class="error-message" id="' + idError + '">' + errorMessage + '</span>'
            );
          }
        } else {
          fieldName.classList.remove('error-border');
          if (isSelectBox) {
            fieldName.nextSibling.classList.remove('error-border');
          }
        }
      }
    } else {
      if (fieldName) {
        if (fieldName.value.trim() == '') {
          fieldName.classList.add('error-border');
          fieldName.insertAdjacentHTML(
            'afterend',
            '<span class="error-message" id="' + idError + '">' + errorMessage + '</span>'
          );
        } else if (!bsLib.validEmail(fieldName.value.trim())) {
          fieldName.classList.add('error-border');
          fieldName.insertAdjacentHTML(
            'afterend',
            '<span class="error-message" id="' + idError + '">' + emailErrorMessage + '</span>'
          );
        } else {
          fieldName.classList.remove('error-border');
        }
      }
    }
  }

  form_validation(
    ContactForm.fnameField,
    ContactForm.fnameError,
    'webinar-fname-error',
    'please share your first name',
    false,
    false
  );
  form_validation(
    ContactForm.emailField,
    ContactForm.webinarModalEmailError,
    'webinar-email-error',
    'please share your email address',
    true,
    false,
    'please share your vaild email address'
  );
  form_validation(
    ContactForm.lnameField,
    ContactForm.lnameError,
    'webinar-lname-error',
    'please share your last name',
    false,
    false
  );

  function contactform_field(field) {
    if (field) {
      return field.value.trim();
    }
    return false;
  }

  if (
    contactform_field(ContactForm.fnameField) === '' ||
    contactform_field(ContactForm.emailField) === '' ||
    !bsLib.validEmail(ContactForm.emailField.value.trim()) ||
    contactform_field(ContactForm.lnameField) === ''
  ) {
    return false;
  } else if (ContactForm.emailField.dataset.notvalid === '1') {
    //check valid email from rails api

    if (ContactForm.emailError) {
      ContactForm.emailError.remove();
    }

    ContactForm.emailField.classList.add('error-border');
    ContactForm.emailField.insertAdjacentHTML(
      'afterend',
      '<span class="error-message" id="webinar-email-error">' +
        Messages.salesAndSupportPage.invalidWorkEmail +
        '</span>'
    );

    return false;
  } else {
    var submitBtn = document.getElementById('webinar-modal-submit'),
      webinarFormBlock = document.getElementById('webinar-modal-container'),
      formPageUrl = document.getElementById('webinar-modal-page-url'),
      formListId = document.getElementById('webinar-modal-list-id'),
      formTag = document.getElementById('webinar-modal-tag'),
      formPostId = document.getElementById('webinar-modal-post-id'),
      formId = document.getElementById('webinar-modal-id'),
      formCampaignID = document.getElementById('webinar-modal-campaign-id'),
      contactformcaptcha = document.getElementById('webinarformcaptcha'),
      formEventName = document.getElementById('webinar-repurpose-event'),
      formPageView = document.getElementById('webinar-modal-page-view'),
      sfdcCampaignCode = document.querySelector('[name="webinar_modal_utm_campaigncode"]'),
      sfdcAdditionalNotes = document.querySelector('[name="webinar_modal_additional_notes"]'),
      sfdcPrimaryProduct = document.querySelector('[name="webinar_modal_primary_product"]'),
      sfdcSecondaryProduct = document.querySelector('[name="webinar_modal_secondary_product"]');

    submitBtn.setAttribute('disabled', 'disabled');
    submitBtn.value = submitBtn.dataset.btndisabled;

    var dataRequest = {
      action: 'bstack_instapage_form_ajax',
      security: ajax_initialize_script.ajax_nonce, // nonce
      'form-email': ContactForm.emailField.value.trim(),
      'form-name': ContactForm.fnameField.value.trim(),
      'form-company': ContactForm.lnameField.value.trim(),
      'form-page-url': formPageUrl ? formPageUrl.value : '',
      'form-list-id': formListId ? formListId.value : '',
      'form-tag': formTag ? formTag.value.trim() : '',
      'form-post-id': formPostId ? formPostId.value : '',
      'form-id': formId ? formId.value : '',
      'form-campaign-id': formCampaignID ? formCampaignID.value.trim() : '',
      'form-event-name': formEventName.value.trim(),
      ga_cid: bsLib.GAClientID(),
      utm_campaigncode: sfdcCampaignCode.value.trim(),
      additional_notes: sfdcAdditionalNotes.value.trim(),
      primary_product: sfdcPrimaryProduct.value.trim(),
      secondary_product: sfdcSecondaryProduct.value.trim(),
      page_url: window.location.href,
      previous_page_url: (document.referrer !== '') ? document.referrer : 'organic',
    };

    if (contactformcaptcha) {
      var grecaptchaResponse = typeof grecaptcha !== 'undefined' ? grecaptcha.getResponse(captchaWidgetId) : '';

      dataRequest['g-recaptcha-response'] = grecaptchaResponse;

      if (grecaptchaResponse.length === 0) {
        new bsAlert({
          alertType: 'error',
          timeout: 5000,
          text: Messages.salesAndSupportPage.noRecaptcha,
        });

        return false;
      }
    }

    //ajax request
    bsLib.ajax(
      'POST',
      websiteHost + '/wp-admin/admin-ajax.php',
      dataRequest,
      true,
      {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      }, //request header
      // Success message for user token.
      function (data) {
        if (data.readyState === 4) {
          submitBtn.removeAttribute('disabled');
          submitBtn.value = submitBtn.dataset.btntext;

          var dataResponse = bsLib.JSONParse(data.response);
          if (dataResponse.status === 1) {
            // add class in body for GA4 events
            document.querySelector('body').classList.add('webinar-main-lp-form');

            if (formId.value === 'webinars') {
              if (window.lintrk !== undefined) {
                window.lintrk('track', { conversion_id: 9342737 });
              }
            }

            //revsure form tracking code on success
            if (typeof window.rudderanalytics !== "undefined") {
              window.rudderanalytics.identify(dataRequest["form-email"], {email: dataRequest["form-email"], name: dataRequest["form-name"]});
              window.rudderanalytics.track("Form Submission - Webinar Form");
            }

            //common room form tracking code on success
            if (typeof window.signals !== 'undefined') {
              window.signals.identify({email: demoChatInfo.emailId, name: demoChatInfo.name});
            }

            if (typeof ga !== 'undefined') {
              //GA Pageview
              if (formPageView) {
                ga('browserstack.send', 'pageview', formPageView.value);
              }

              //Recotap GA Goal tracking
              ga('browserstack.send', 'event', 'recotap_event', 'conversion', 'webinar_registration');
            }

            //reset form
            webinarFormBlock.querySelector('form').reset();

            captchaWidgetId = undefined;

            // Add class in body for YT video on click
            document.body.classList.add('event-webinar-repurpose-lp');

            //YT modal open
            var getModalFormTags = document.getElementById('webinar-modal-tag'),
              getModalCampaignID = document.getElementById('webinar-modal-campaign-id'),
              getModalMailchimpID = document.getElementById('webinar-modal-list-id'),
              getModalYTVideoLink = document.getElementById('webinar-modal-yt-link'),
              setModalPageViewValue = document.getElementById('webinar-modal-page-view'),
              sfdcCampaignCode = document.querySelector('[name="webinar_modal_utm_campaigncode"]'),
              sfdcAdditionalNotes = document.querySelector('[name="webinar_modal_additional_notes"]'),
              sfdcPrimaryProduct = document.querySelector('[name="webinar_modal_primary_product"]'),
              sfdcSecondaryProduct = document.querySelector('[name="webinar_modal_secondary_product"]'),
              mainModalVideoId = getModalYTVideoLink.value.trim(),
              sandboxFlag = fnSetSandboxFlagIframe(),
              custModalVideo = new tingle.modal({
                closeIconInverse: true,
                cssClass: ['webinar-yt-modal'],
                onOpen: function () {
                  webinarModal.destroy();
                },
                onClose: function () {
                  document.querySelector('body').classList.remove('webinar-main-lp-form');
                  custModalVideo.destroy();
                },
              });

            custModalVideo.setContent(
              '<iframe class="webinar-yt-modal__frame" width="100%" height="400" src="https://www.youtube.com/embed/' +
                mainModalVideoId +
                '?autoplay=1" sandbox="allow-scripts allow-same-origin ' +
                sandboxFlag +
                '" frameborder="0" allow="autoplay; fullscreen"></iframe>'
            );
            custModalVideo.open();

            // reset all hidden values
            getModalFormTags.value = '';
            getModalCampaignID.value = '';
            getModalMailchimpID.value = '';
            getModalYTVideoLink.value = '';
            setModalPageViewValue.value = '';

            //reset sfdc fields
            sfdcCampaignCode.value = '';
            sfdcAdditionalNotes.value = '';
            sfdcPrimaryProduct.value = '';
            sfdcSecondaryProduct.value = '';
          } else {
            new bsAlert({
              alertType: 'error',
              timeout: false,
              text: dataResponse.errormsg,
            });
          }
        }
      },
      // Custom Error message for user token.
      function () {}
    );
  }
  return false;
}

var openWebinarYTVideoModal = document.querySelectorAll('.open-yt-modal');

for (var i = 0; i < openWebinarYTVideoModal.length; i++) {
  openWebinarYTVideoModal[i].addEventListener(
    'click',
    function (evt) {
      evt.preventDefault();
      var custModalVideoId = this.getAttribute('data-video-id'),
        sandboxFlag = fnSetSandboxFlagIframe();

      if (custModalVideoId) {
        fnOpenYTModalFrame(custModalVideoId, sandboxFlag);
      }
    },
    false
  );
}

// function for fetching the sandbox flags for Iframe
function fnSetSandboxFlagIframe() {
  var ua = navigator.userAgent.toLowerCase(),
    isSafari = false,
    sandboxFlag = '';

  // Detect browser for allow presentation sandbox flag
  try {
    isSafari =
      /constructor/i.test(window.HTMLElement) ||
      (function (p) {
        return p.toString() === '[object SafariRemoteNotification]';
      })(!window['safari'] || safari.pushNotification);
  } catch (err) {}

  isSafari = isSafari || (ua.indexOf('safari') != -1 && !(ua.indexOf('chrome') != -1) && ua.indexOf('version/') != -1);
  sandboxFlag = isSafari ? '' : 'allow-presentation';

  return sandboxFlag;
}

// function for opening YT video modal on success
function fnOpenYTModalFrame(custModalVideoId, sandboxFlag) {
  var custModalVideo = new tingle.modal({
    closeIconInverse: true,
    cssClass: ['webinar-yt-modal'],
    onClose: function () {
      custModalVideo.destroy();
    },
  });

  custModalVideo.setContent(
    '<iframe class="webinar-yt-modal__frame" width="100%" height="400" src="https://www.youtube.com/embed/' +
      custModalVideoId +
      '?autoplay=1" sandbox="allow-scripts allow-same-origin ' +
      sandboxFlag +
      '" frameborder="0" allow="autoplay; fullscreen"></iframe>'
  );
  custModalVideo.open();
}
